import React from "react";
import PropTypes from "prop-types";

const DefaultHeader = (props) => {
	return (
		<div className="discovery-section-title">
			<span className="discovery-section-title-text">
				{props.title}
			</span>
		</div>
	);
};

DefaultHeader.propTypes = {
	title: PropTypes.string.isRequired,
};

export default DefaultHeader;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/headers/DefaultHeader.jsx